<template>
    <div
        class="wrapper-bg container-history-earn-point coffee-editprofile main-layout addcode"
    >
        <HeaderTitleSvg
            :setTitle="titilesvg"
            :setHref="'profile'"
            :showLogo="true"
        />
        <div class="text-white"></div>
        <div v-if="isLoaded" class="wrapper-table-history-point">
            <form ref="form-profile">
                <div class="input-container mb-2">
                    <InputText
                        id="editprofile-name-input"
                        inputId="first-name"
                        :inputLbl="lbl.profile.firstname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :errorInfo="errorInfo[0]"
                        @input="onInput"
                        v-model="modelProfile.firstName"
                    ></InputText>
                </div>
                <div class="input-container mb-2">
                    <InputText
                        id="editprofile-name-input"
                        inputId="first-name"
                        :inputLbl="lbl.profile.contactnumber"
                        :disabled="true"
                        v-model="modelProfile.ContactNumber"
                    ></InputText>
                </div>
                <div class="number-container mb-2">
                    <span
                        id="editprofile-contactnumber-btn"
                        class="edit-btn"
                        @click="changeTel"
                    >
                        แก้ไข
                    </span>
                </div>
                <div class="input-container mb-2">
                    <InputEmail
                        id="editprofile-email-input"
                        inputId="email"
                        :inputLbl="lbl.profile.email"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="false"
                        :isShowLabel="true"
                        :errorInfo="errorInfo[3]"
                        @input="onInput"
                        v-model="modelProfile.proEmail"
                    ></InputEmail>
                </div>
                <div class="input-container mb-2">
                    <InputText
                        id="editprofile-address-input"
                        inputId="address"
                        :inputLbl="lbl.profile.address"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="false"
                        :errorInfo="errorInfo[4]"
                        :isAddress="true"
                        @input="onInput"
                        v-model="modelProfile.address"
                    ></InputText>
                </div>
                <FormAddressDropdown
                    :address="modelProfile"
                    form-id="shipping"
                    id="editprofile-address-dropdown"
                    :lbl-shipping="lbl.shipping"
                    :is-first-save="isFirstSave"
                    :is-show-error-lbl="false"
                    :zipcode-error="errorInfo[5]"
                    :sub-district-error="errorInfo[6]"
                    :district-error="errorInfo[7]"
                    :province-error="errorInfo[8]"
                    @input="onInput"
                ></FormAddressDropdown>
            </form>
            <div class="modal-base-footer row box-footer">
                <div class="btn-submit-wrapper">
                    <button
                        class="btn-submit savebtn"
                        :disabled="!formState"
                        @click="clickSaveProfile()"
                    >
                        บันทึก
                    </button>
                </div>
            </div>
        </div>
        <div>
            <b-modal
                id="modalVerifyOtp"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="otp-main">
                    <div
                        class="close-btn"
                        @click="$bvModal.hide('modalVerifyOtp')"
                    >
                        <img src="@/assets/profile/close@2x.png" alt="" />
                    </div>
                    <div class="otp-header">
                        <div class="title-otp">
                            <h2>OTP</h2>
                        </div>
                        <div class="otp-container">
                            <div class="otp-desc">
                                ระบบได้ส่งรหัส OTP ไปยังเบอร์โทรศัพท์มือถือ
                            </div>
                            <div class="otp-detail">
                                <div class="contact-number">
                                    {{ formatted(tel) }}
                                </div>
                                <div class="ref-code">
                                    รหัสอ้างอิง {{ refcode }}
                                </div>
                            </div>
                            <div class="text-center">
                                <label
                                    for="input-otp"
                                    :class="{ 'input-otp': !isErrorMessage }"
                                >
                                    <div class="d-flex justify-content-center">
                                        <div
                                            class="box-input-otp"
                                            :class="{ error: !isExpireTime }"
                                        >
                                            {{ otp[0] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{ error: !isExpireTime }"
                                        >
                                            {{ otp[1] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{ error: !isExpireTime }"
                                        >
                                            {{ otp[2] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{ error: !isExpireTime }"
                                        >
                                            {{ otp[3] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{ error: !isExpireTime }"
                                        >
                                            {{ otp[4] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{ error: !isExpireTime }"
                                        >
                                            {{ otp[5] }}
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <input
                                type="tel"
                                id="input-otp"
                                class="input-otp-dummy"
                                maxlength="6"
                                v-model="otp"
                                @input="onOtpChange()"
                            />
                            <div class="err-otp" v-if="isErrorMessage">
                                {{ errorMessage }}
                            </div>
                            <div class="resend" v-if="isExpireTime">
                                ส่งรหัส OTP อีกครั้ง ในเวลา
                                <span class="timer">{{
                                    timeHelper.displayTime
                                }}</span>
                            </div>
                            <div
                                id="editprofile-resendotp-btn"
                                class="resend"
                                v-if="!isExpireTime"
                                :class="{ expired: !isExpireTime }"
                                @click="resendOtp()"
                            >
                                ส่งรหัส OTP อีกครั้ง
                            </div>
                        </div>
                        <div class="otp-btn" @click="onSubmitOtp()">
                            ยืนยันรหัส
                        </div>
                    </div>
                </div>
            </b-modal>
        </div>
        <div>
            <b-modal
                id="modalSuccessUpdate"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="success-main">
                    <div
                        class="close-btn"
                        @click="$bvModal.hide('modalSuccessUpdate')"
                    >
                        <img src="@/assets/profile/close@2x.png" alt="" />
                    </div>
                    <div class="success-header">
                        <div class="title-scc">
                            <h2>บันทึกข้อมูลสำเร็จ</h2>
                            <p>ระบบได้บันทึกข้อมูลของท่านสำเร็จแล้ว</p>
                        </div>
                    </div>
                    <div
                        id="editprofile-successmodal-back-btn"
                        class="success-btn"
                        @click="$router.push('/profile')"
                    >
                        กลับหน้าข้อมูลของฉัน
                    </div>
                </div>
            </b-modal>
        </div>
        <div>
            <b-modal
                id="modalFailUpdate"
                modal-class="modal-register"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="modal-base">
                    <div clas="row draw">
                        <div class="col-12 text-center mt-2">
                            <img
                                class="error-icon"
                                src="@/assets/addcode/ic_error.png"
                                alt="icon_error"
                            />
                            <div class="title-scc">ขออภัย ข้อมูลไม่ถูกต้อง</div>
                            <div class="btn-back" @click="close">
                                กลับไปบัญชี
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
// helper
import Account from "@/helper/AccountHelper.js";
//mixin
import Mixin from "@/mixin/Mixin";
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
// component
import InputText from "@/components/Input/EditText.vue";
import InputEmail from "@/components/Input/EditEmail.vue";
import FormAddressDropdown from "@/components/Form/FormAddressDropDownForProfile.vue";
import FormHelper from "@/helper/FormHelper.js";
import HeaderTitleSvg from "@/components/Header/HeaderTitleSvg.vue";
import TimerHelper from "@/helper/TimerHelper.js";
// Service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import CacheHelper from "@/helper/CacheHelper.js";
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";

export default {
    name: "editprofile",
    components: {
        InputText,
        InputEmail,
        FormAddressDropdown,
        HeaderTitleSvg,
    },
    mixins: [Mixin, AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            // lbl: Locale.getLbl(),
            isLogin: false,
            objProfile: {},
            modelProfile: {},
            isFirstSave: true,
            errorInfo: [],
            isLoaded: false,

            titilesvg: require("@/assets/profile/title-edit-profile.svg"),
            isDisabledSubmit: true,

            bzbConfig: Vue.bzbsConfig,

            timeHelper: new TimerHelper(),
            isExpireTime: false,
            otp: "",
            tel: "",
            refcode: "",
            channel: "ssoregis",
            resend: false,

            isErrorMessage: false,
            errorMessage: "",
            formState: true,
        };
    },
    created: function () {
        this.setupForm();
        this.getProfile();
    },
    methods: {
        onInput() {
            this.$forceUpdate();
            this.formState =
                this.modelProfile?.firstName?.trim() &&
                this.modelProfile?.firstName?.trim().split(" ").length == 2 &&
                this.modelProfile?.firstName?.length <= 60 &&
                this.modelProfile?.address?.trim() &&
                this.modelProfile?.zipcode?.trim() &&
                this.modelProfile?.provinceName?.trim() &&
                this.modelProfile?.districtName?.trim() &&
                this.modelProfile?.subDistrictName?.trim() &&
                this.validEmail(this.modelProfile?.proEmail);
        },
        formatted: function (input) {
            var n1, n2, n3;
            if (input) {
                n1 = input.substr(0, 3);
                n2 = input.substr(3, 3);
                n3 = input.substr(6);
                input = n1 + "-" + n2 + "-" + n3;
            }
            return input;
        },
        async getProfile() {
            this.handleLoading(true);
            try {
                const res = await BzbsApi.getProfileSSO(
                    this.cacheHelper.getCache("BzbsUser").token
                );
                this.objProfile = res.data.SSOUser;
                this.modelProfile = res.data.SSOUser;
                let fullName = `${this.objProfile.FirstName} ${this.objProfile.LastName}`;
                this.modelProfile.firstName = fullName;
                this.modelProfile.contactNumber = this.objProfile.ContactNumber;
                this.modelProfile.proEmail = this.objProfile.ProEmail;
                this.modelProfile.address =
                    this.objProfile.Address == "null"
                        ? ""
                        : this.objProfile.Address;
                this.modelProfile.zipcode = this.objProfile.Zipcode;
                this.modelProfile.province = this.objProfile.ProvinceName;
                this.modelProfile.districtName =
                    res.data.SSOUser.StreetDistrict;
                this.modelProfile.subDistrictName =
                    res.data.SSOUser.StreetSubDistrict;
                this.isLoaded = true;
                this.handleLoading(false);
                this.onInput();
            } catch (err) {
                this.errorResponse(err.response.data.error);
            }
        },
        setupForm: function () {
            var { getList, add } = FormHelper.GenderListValue();
            add("ชาย", "male", "ic_active.png", "ic_inactive.png");
            add("หญิง", "female", "ic_active.png", "ic_inactive.png");
            add("ไม่ระบุ", "notspecified", "ic_active.png", "ic_inactive.png");
            this.prefixValue = getList();

            this.errorInfo = FormHelper.genErrorInfo(20);
        },
        close: function () {
            this.$bvModal.hide("modalFailUpdate");
        },
        clickSaveProfile: function () {
            this.isFirstSave = false;

            let token = Account.getToken();

            let nameArray = this.modelProfile.firstName.split(/(\s+)/);
            this.modelProfile.firstName = nameArray[0];
            this.modelProfile.LastName = nameArray[2] || " ";

            let params = this.setParam();
            // let params = this.modelProfile;

            BzbsProfile.updateProfileSSO(token, params).subscribe(
                (data) => {
                    this.$bvModal.show("modalSuccessUpdate");
                    console.log(data);
                },
                (err) => {
                    this.$bvModal.show("modalFailUpdate");
                    console.log(err);
                }
            );
        },
        onDatePickerSelected: function (obj) {
            console.log(obj.timestamp);
            this.modelProfile.birthDate = obj.timestamp;
        },
        onFormChange: function () {
            this.$emit("onFormChange");
        },
        changeTel: function () {
            this.$router.push("/changetel");
        },
        //#region otp
        onclickOtp: async function () {
            this.tel = this.modelProfile.contactNumber;
            await this.apiRequestOtp();
            //set timeout to 5 minutes
            this.timeHelper.initialTimer(60 * 5, null, false, false);
            this.startOtp();
            this.$bvModal.show("modalVerifyOtp");
        },
        apiRequestOtp: async function () {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(this.tel, null, this.channel).subscribe(
                    (data) => {
                        this.refcode = data.refcode;
                        resolve(true);
                    },
                    (err) => {
                        console.log(err);
                        reject(false);
                    }
                );
            });
        },
        startOtp: async function () {
            this.isExpireTime = false;
            if (this.resend === false) {
                this.tel = this.modelProfile.contactNumber;
            } else {
                this.timeHelper.stopTimer();
                this.timeHelper.resetTimer();
            }

            this.otp = "";

            this.isErrorMessage = false;

            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });
            this.isExpireTime = true;
        },
        cancelOtp: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();

            this.$store.commit("setDupphone", {
                isdup: false,
                message: "",
            });
        },
        onOtpChange: function () {
            this.otp = this.otp.replace(/\D/g, "");
        },
        setTimeout: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = false;
        },
        onSubmitOtp: async function () {
            if (this.validateOtp()) {
                await this.apiValidateOtp();
            }
            this.$bvModal.hide("modalVerifyOtp");
        },
        apiValidateOtp: async function () {
            console.log(this.refcode);
            return new Promise((resolve, reject) => {
                BzbsOtp.validateNestleOtp(
                    this.tel,
                    this.refcode,
                    this.otp
                ).subscribe(
                    (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    (err) => {
                        this.isErrorMessage = true;
                        this.errorMessage = err.message;
                        if (err.message === "รหัส OTP ไม่ถูกต้อง") {
                            this.errorMessage =
                                "รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง";
                        }
                        this.isExpireTime = false;
                        console.log(this.errorMessage);
                        reject(false);
                    }
                );
            });
        },
        validateOtp: function () {
            if (this.otp.length != 6) {
                this.errorMessage = this.lbl.otp.otpLength;
                if (this.otp == "") {
                    this.errorMessage = this.lbl.otp.requireInput;
                }
                this.isErrorMessage = true;
                return false;
            }

            return true;
        },
        resendOtp: async function () {
            this.isExpireTime = false;
            this.isErrorMessage = false;

            await this.clickResend();
            this.resend = true;
            await this.startOtp();
        },
        clickResend: async function () {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(this.tel, null, this.channel).subscribe(
                    (data) => {
                        this.refcode = data.refcode;
                        resolve(true);
                    },
                    (err) => {
                        // this.controller.loadingModal.hide();
                        // if (err.id == 2078) {
                        //     this.controller.alertModal
                        //         .clearText()
                        //         .setMsg(err.message)
                        //         .show();
                        //     this.controller.alertModal.onClickOk(() => {
                        //         this.controller.sendCallbackError(err);
                        //     });
                        // } else {
                        //     this.errorResponse(err);
                        // }
                        console.log(err);
                        reject(false);
                    }
                );
            });
        },
        setParam: function () {
            console.log(this.modelProfile, "this.modelProfile");
            let params = {};
            if (this.modelProfile.firstName) {
                params.firstName = this.modelProfile.firstName;
            }
            if (this.modelProfile.LastName) {
                params.LastName = this.modelProfile.LastName;
            }
            if (this.modelProfile.proEmail) {
                params.proEmail = this.modelProfile.proEmail;
            }
            if (this.modelProfile.address) {
                params.address = this.modelProfile.address || "";
            }
            if (this.modelProfile.zipcode) {
                params.zipcode = this.modelProfile.zipcode;
            }
            if (this.modelProfile.provinceCode) {
                params.provinceCode = this.modelProfile.provinceCode;
            }
            if (this.modelProfile.provinceName) {
                params.provinceName = this.modelProfile.provinceName;
            }
            if (this.modelProfile.districtName) {
                params.streetDistrict = this.modelProfile.districtName;
            }
            if (this.modelProfile.subDistrictName) {
                params.streetSubDistrict = this.modelProfile.subDistrictName;
            }
            return params;
        },
        validEmail: function (email) {
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Profile/style/editprofile.scss";
.savebtn {
    width: 100%;
    border: none;
    &:disabled {
        background-color: #6d6d6d !important;
    }
}
</style>
